module.exports = __webpack_public_path__ + "static/media/dashboard.94ed6c3a.svg";